/**
 * TMR Report config.
 * Registers the main report state, which has no route.
 *
 * @type {ngConfig}
 */
let tmrReportConfig = /*@ngInject*/ $stateProvider =>
  $stateProvider.state({
    name: 'app.report',
    label: 'REPORT.TITLE',
    abstract: true,
    mainMenu: true,
    accessControl: [],
    weight: 2,
    url: '/reports',
    icon: 'o-clipboard-1',
  })

export { tmrReportConfig as config }
